
console.log("custom ADA fires ")
 
const targetNode = document.querySelector('#stamped-reviews-widget');

const observerR = new MutationObserver((mutations) => {
    mutations.forEach((mutation,i) => { 
        // console.log(mutations?.length - 1 === i   ,"show mutation here ",i )
        if (mutation.type === 'childList') { 
            if(mutations?.length - 1 === i) {

            }
            
        }
    });
});

observerR.observe(targetNode, { childList: true, subtree: true });




setTimeout(() => {
    
    

        // $('#stamped-reviews-widget').addClass('not-active');
        $('.stamped-widget-button').attr({'tabindex':'0', 'role':'button'}); 
        
        
        // $(document).off().on('click','.stamped-widget-button',function(e) {
        //     // $('#stamped-widget-drawer').removeClass('not-active');
        //     // console.log('key up is firing') 
        //     // if(e.which == 13 || e.key == "Enter") {
        //     //     $(this).trigger('click');
        //         $('#stamped-reviews-widget').toggleClass('not-active');
        //     // }   
        // })

        // $(document).off().on('keyup','.stamped-widget-button',function(e) {
        //     // $('#stamped-widget-drawer').removeClass('not-active');
        //     console.log('key up is firing')
        //     if(e.which == 13 || e.key == "Enter") {
                
        //         // $('#stamped-reviews-widget').removeClass('not-active'); 
        //         $(this).trigger('click'); 
        //     }   
        // })
    
    
    $(document).on('keyup','modal-close',function(e) {
        if(e.which == 13 || e.key == "Enter") {
            $(this).trigger('click');
            $('modal-trigger').find('button').attr('aria-expanded','false');
        }
    });
    $(document).on('keyup','collection-active-filter',function(e) {
        if(e.which == 13 || e.key == "Enter") {
        $(this).trigger('click');
    }
    });
    
        
        if($('.stamped-header-title').length) {
    let text=$('.stamped-header-title').text();
    $('.stamped-header-title').replaceWith('<h2>'+text+'</h2>'); 
}

if($('[data-cart-notification]').length) {
    $('[data-cart-notification]').closest('dialog').attr('aria-label','Product added to cart overview');
}

}, 5000); 


document.addEventListener("DOMContentLoaded", () => {
    const currentLoc = window.location.href;
    if (currentLoc.includes("privacy-policy")){
        if (!!document.querySelector(".shopify-policy__container .shopify-policy__body  h5 + p")){
            const levelTwoHead = document.querySelector(".shopify-policy__container .shopify-policy__body h5  + p");
            levelTwoHead.setAttribute("aria-level", "2")
            levelTwoHead.setAttribute("role", "heading")
            
        }
        if (!!document.querySelector(".shopify-policy__container .shopify-policy__body h5") ){
            const headingElement = document.querySelector(".shopify-policy__container .shopify-policy__body h5")
            const divElement =  document.createElement("div");
            divElement.setAttribute("lang", "es");
            divElement.innerHTML = headingElement.innerHTML;
            headingElement.replaceWith(divElement);
        } 
    }
    if(currentLoc.includes("accessibility")){
        if (window.innerWidth < 600){
            if (!!document.querySelector(".Accessibility h2:first-child")){
                document.querySelector(".Accessibility h2:first-child").setAttribute("style", "")
            }
        }
        window.addEventListener("resize", function(){
            if (window.innerWidth < 600){
                if (!!document.querySelector(".Accessibility h2:first-child")){
                    document.querySelector(".Accessibility h2:first-child").setAttribute("style", "")
                }
            }
        })
    }

    const productStar=document.querySelectorAll('.stamped-product-reviews-badge')

    if(productStar?.length > 0 ) {

        productStar.forEach(item=>{
            const badge=item.querySelector('.stamped-badge')
            if(badge) {
                const caption = item.querySelector('.stamped-badge-caption')
                caption.removeAttribute('aria-label')
                const text=badge.getAttribute('aria-label')
                const element=document.createElement('span')
                element.classList.add('visually-hidden')
                element.textContent=text
                item.appendChild(element)
                badge.removeAttribute('aria-label')
                badge.setAttribute('aria-hidden','true')
            }
        })
        
    }   
  
    if(document.querySelector('.shipping-content-pdp')) {
        const elements=document.querySelector('.shipping-content-pdp').querySelectorAll('strong')
        if(elements.length) {
            elements.forEach(element=>{
                element.setAttribute('role','heading')
                element.setAttribute('aria-level','3')
            })
        }
    }

    
    if($('.privacy-lang a').length) {
        $('.privacy-lang a').attr({'lang':'es'}) 
    }


});




